import { AppRoutes } from "@/routes/config";
import { logout } from "@/utils/logout";
import { createUrlWithParams } from "@/utils/url";
import { useEffect } from "react";

const Logout = () => {
  useEffect(() => {
    const handleLogout = async () => {
      // logout() revokes the refresh token server-side (best effort) and returns
      // the email of the cleared session so /login stays pre-filled.
      const email = await logout();
      window.location.replace(createUrlWithParams(AppRoutes.login, { email }));
    };

    handleLogout();
  }, []);

  return null;
};

export default Logout;
